import styled from 'styled-components';

import BaseCard from '../BaseCard';

const FullScreenCard = styled(BaseCard)`
  display: flex;
  width: 100%;
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
`;

export default FullScreenCard;
